import {Component, OnInit} from '@angular/core';
import {ReportComponent} from "../report/report.component";
import {Report} from "../report/report";
import {Utils} from "../utils";

declare var $: any;

@Component({
    selector: 'app-report-detail',
    templateUrl: '../report/report.component.html',
    styleUrls: ['../report/report.component.css']
})
export class ReportDetailComponent extends ReportComponent implements OnInit {


    ngOnInit() {
        super.ngOnInit();

        this.route.params.subscribe(params => this.id = +params['id']);
        // this.show(this.id);
        this.service.show(this.id)
            .then(model => {
                this.model = (model);
                let campos = this.model.campos;
                let colunas = this.model.colunas;
                let tabela = this.model.tabela;
                // this.model.campos = campos != '' && campos != null ? campos.split(",") : '';
                this.model.campos = Utils.explode(campos);
                this.model.colunas = Utils.explode(colunas);
                this.model.tabela = Utils.explode(tabela);
                if (this.model.mostrartodos) {
                    $("input[name=mostrartodos][value=true]").click();
                } else {
                    $("input[name=mostrartodos][value=false]").click();
                }
                this.getcols();
            });
    }

    submit(model) {
        if (!model.campos.length) {
            model.campos = '';
        }
        this.update(model);
    }
}



// WEBPACK FOOTER //
// ./src/app/report-detail/report-detail.component.ts